import { create } from "zustand";
import { persist } from "zustand/middleware";
import { Theme } from "./theme";

interface ColorSchemeStore {
	theme: Theme;
	setTheme: (theme: Theme) => void;
}

const storageName = "theme";

export const useColorSchemeStore = create(
	persist<ColorSchemeStore>(
		(set) => ({
			theme: Theme.system,
			setTheme: (theme: Theme) => set({ theme }),
		}),
		{
			name: storageName,
		},
	),
);

window.addEventListener("storage", (e) => {
	if (e.key !== storageName) return;
	useColorSchemeStore.persist.rehydrate();
});
